import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";
import { Fleet } from "../../../../types/fleets.types";
import { getFleetsByClient } from "../../../../services/fleetService";

interface Props {
  clientId: string;
  fleet: Fleet | null;
  onChange: (fleet: Fleet | null) => void;
}

const SelectFleet: React.FC<Props> = ({ clientId, fleet, onChange }) => {
  const [fleets, setFleets] = useState<Fleet[]>([]);

  useEffect(() => {
    if (!clientId) {
      setFleets([]);
      onChange(null);
      return;
    }
    getFleetsByClient(clientId)
      .then(setFleets)
      .catch(() => setFleets([]));
  }, [clientId]);

  const handleChange = (e: any) => {
    const selected = fleets.find((f) => f.id === e.target.value) ?? null;
    onChange(selected);
  };

  return (
    <Box sx={{ minWidth: 200 }}>
      <FormControl fullWidth disabled={!clientId}>
        <InputLabel variant="outlined" htmlFor="select-fleet-vehicle">
          Frota
        </InputLabel>
        <Select
          labelId="select-fleet-vehicle"
          value={fleet?.id ?? ""}
          label="Frota"
          onChange={handleChange}
        >
          {fleets.map((f) => (
            <MenuItem key={f.id} value={f.id}>
              {f.description}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectFleet;
